import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { getLabel } from '@/helpers/Utils';

export const fetchEmploymentType = createAsyncThunk(
  'employeeType/fetchEmploymentType',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetEmployeeType();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          code: item.code,
          label: item.name,
          value: item.id,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  employmentTypeList: [],
  loading: false,
  error: '',
};

const employmentTypeSlice = createSlice({
  name: 'employeeType',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmploymentType.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmploymentType.fulfilled, (state, action) => {
        state.loading = false;
        state.employmentTypeList = action.payload;
        state.error = '';
      })
      .addCase(fetchEmploymentType.rejected, (state, action) => {
        state.loading = false;
        state.employmentTypeList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default employmentTypeSlice.reducer;
